// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"418":"a88dce21","946":"fb17008b","975":"eb412cc2"}[chunkId] + ".chunk.js";
};